import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { PosModal } from '../pos/PosModal';

export function AppLayout() {
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname]);

  return (
    <div className={`app-shell${navOpen ? ' app-shell--nav-open' : ''}`}>
      <Sidebar onNavigate={() => setNavOpen(false)} />
      {navOpen ? (
        <button
          type="button"
          className="nav-backdrop"
          aria-label="Cerrar menú de navegación"
          onClick={() => setNavOpen(false)}
        />
      ) : null}
      <div className="main-column">
        <Topbar onMenu={() => setNavOpen(true)} />
        <main className="page">
          <Outlet />
        </main>
      </div>
      <PosModal />
    </div>
  );
}
